<template>
  <!-- Any tag modification will change how froala data is saved. See saveWithHtml method -->
  <!-- eslint-disable vue/no-v-html -->
  <div class="froala-root" v-html="workingContent"></div>
</template>

<script>
import FroalaEditor from 'froala-editor/js/froala_editor.min'
import {
  FroalaAfterCommand,
  FroalaBeforeCommand,
} from '@/js/components/common/froala-after-command'

export default {
  name: 'FroalaTextEditor',
  props: {
    content: {
      type: String,
      required: true,
    },
    config: { type: Object, required: true },
    tag: { type: String, default: 'div' },
    saveInterval: { type: Number, default: 1000 },
  },
  data() {
    return {
      editor: null,
      currentConfig: null,
      editorCreated: false,
      workingContent: '<br>',
      lastEmittedHtml: null,
    }
  },
  created() {
    // Initialize the working content with the provided content.
    // This is necessary to avoid component reactivity issues
    this.workingContent = this.content
  },
  mounted() {
    this.createEditor()
  },
  destroyed() {
    this.shutdown()
  },
  methods: {
    shutdown() {
      if (this.$el) {
        this.editor.destroy()
      }
    },
    createEditor() {
      if (this.editorCreated) return

      const currentConfig = Object.assign({}, this.config)

      const defaultConfig = {
        ...currentConfig,
        saveInterval: 1000,
        // Set the save param.
        saveParam: 'content',
        // Set the save URL.
        saveURL: '#',
        // HTTP request type.
        saveMethod: 'POST',
        events: {
          ...(currentConfig.events || {}),
          'save.before': (html) => {
            this.saveWithHtml(html)
            return false
          },
          contentChanged: () => {
            this.$emit('contentChanged', this.workingContent)
          },
          'commands.before': function (cmd, param1, param2) {
            // Handle CSS variable colors before Froala's default handling
            return FroalaBeforeCommand(this, cmd, param1, param2)
          },
          'commands.after': function (cmd, param1, param2) {
            FroalaAfterCommand(this, cmd, param1, param2, [])
            if (['textColor', 'backgroundColor'].includes(cmd)) {
              return false
            }
            this.save.save()
          },
        },
      }
      this.editor = new FroalaEditor(this.$el, defaultConfig)
      this.editorCreated = true
    },
    saveWithHtml(html) {
      if (html === this.lastEmittedHtml) return
      this.lastEmittedHtml = html
      this.$emit('change', html)
    },
  },
}
</script>

<style scoped lang="scss"></style>
